<template>
  <div class="unauthorized-page">
    <div class="unauthorized-box">
      <h1 class="title">🚫 無權限存取</h1>
      <p class="message">很抱歉，您沒有足夠的權限瀏覽此頁面。<br>請聯絡您的管理員以獲取必要的存取權限。</p>
      <router-link to="/login" class="home-link">返回登入</router-link>
    </div>
  </div>
</template>

<script>
export default {
  name: 'UnauthorizedView'
}
</script>

<style scoped>
/* @import url('https://fonts.googleapis.com/css2?family=Cinzel:wght@400;700&family=Roboto:wght@300;400;700&display=swap'); */

.unauthorized-page {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 100vh;
  background-color: #121212;
  background-image:
      radial-gradient(ellipse at bottom, rgba(80, 20, 80, 0.3) 0%, transparent 60%),
      linear-gradient(to bottom, rgba(10, 10, 15, 0.9) 0%, rgba(20, 20, 30, 0.95) 70%, #0a0a0a 100%);
  padding: 20px;
  box-sizing: border-box;
  font-family: 'Roboto', 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
  /* font-family: 'Cinzel', serif; */
  overflow: hidden;
}

.unauthorized-box {
  background-color: rgba(25, 25, 35, 0.65); /* Slightly more opaque for readability */
  padding: 50px 60px; /* More padding for this type of message */
  border-radius: 10px;
  box-shadow: 0 0 35px rgba(0, 0, 0, 0.75), inset 0 0 12px rgba(120, 80, 180, 0.15);
  text-align: center;
  width: 100%;
  max-width: 550px; /* Can be a bit wider for text content */
  animation: fadeInRise 0.8s ease-out forwards;
  border: 1px solid rgba(160, 100, 220, 0.6); /* Purple border */
  position: relative;
}

@keyframes fadeInRise {
  from {
    opacity: 0;
    transform: translateY(30px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.title {
  font-size: 32px; /* Larger for emphasis */
  font-weight: 700;
  color: #ff8c69; /* Fiery orange-red */
  margin-bottom: 25px;
  text-shadow: 0 0 10px rgba(255, 140, 105, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
}

.title .emoji { /* If you want to style emoji separately, not really needed for 🚫 */
  margin-right: 10px;
  font-size: 36px;
}

.message {
  font-size: 17px;
  color: #b0b0c0; /* Slightly lighter for better readability of more text */
  margin-bottom: 35px;
  line-height: 1.7;
}

.home-link {
  display: inline-block;
  padding: 10px 25px;
  background: linear-gradient(145deg, #503070, #704090 ); /* Purple-ish button */
  color: #e0e0e0;
  border: 1px solid rgba(180, 120, 220, 0.7);
  border-radius: 6px;
  text-decoration: none;
  font-weight: 500;
  transition: all 0.2s ease-in-out;
  font-size: 16px;
}

.home-link:hover {
  background: linear-gradient(145deg, #604080, #8050a0 );
  border-color: rgba(200, 140, 240, 0.8);
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(120, 80, 180, 0.3);
}

/* Responsive */
@media (max-width: 600px) {
  .unauthorized-box {
    padding: 40px 30px;
    max-width: 90%;
  }

  .title {
    font-size: 26px;
  }
  .title .emoji {
    font-size: 30px;
  }

  .message {
    font-size: 15px;
  }
  .home-link {
    font-size: 15px;
    padding: 9px 20px;
  }
}
</style>